import { enqueueSnackbar } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	GetVismonLastUpdateRequest,
	GetSiteListRequest,
	GetParameterPlanningTableRequest,
	RunParameterPlanningRequest,
	GetParameterPlanningExportRequest
} from '../requests/ParameterPlanningRequests.js';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_VISMON_LAST_UPDATE = 'GET_VISMON_LAST_UPDATE';
export const GET_SITE_LIST = 'GET_SITE_LIST';
export const GET_PARAMETER_PLANNING_TABLE = 'GET_PARAMETER_PLANNING_TABLE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

const onGetVismonLastUpdate = (value) => ({
	type: GET_VISMON_LAST_UPDATE,
	vismonLastUpdate: value
});

export const GetVismonLastUpdate = () => async (dispatch) => {
	await GetVismonLastUpdateRequest().then(response => {
		dispatch(onGetVismonLastUpdate(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetSiteList = (value) => ({
	type: GET_SITE_LIST,
	siteList: value
});

export const GetSiteList = () => async (dispatch) => {
	await GetSiteListRequest().then(response => {
		dispatch(onGetSiteList(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetParameterPlanningTable = (value) => ({
	type: GET_PARAMETER_PLANNING_TABLE,
	parameterPlanningTableData: value
});

export const GetParameterPlanningTable = () => async (dispatch) => {
	await GetParameterPlanningTableRequest().then(response => {
		dispatch(onGetParameterPlanningTable(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RunParameterPlanning = (siteId, antenna, lteBands, userId) => async (dispatch) => {
	await RunParameterPlanningRequest(siteId, antenna, lteBands, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetParameterPlanningExport = (parameterPlanningId) => async (dispatch) => {
	await GetParameterPlanningExportRequest(parameterPlanningId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
